import React from 'react';
import Box from '@mui/material/Box';
import { EMOJIES } from './view/Reactions';

const EmojiReactions = ({ emojiName }) => {
  return (
    <Box className="emojies-container">
      {[...Array(100)].map(() => {
        return (
          <img
            className="emoji-element"
            src={EMOJIES.find((ele) => ele.value === emojiName).img}
            alt="emoji"
          />
        );
      })}
    </Box>
  );
};

export default EmojiReactions;
